import React from 'react';

import FieldList_TableGroup from '../../../components/plain/FieldList_TableGroup';

class TabAAEducation extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '10px' }}>
				<FieldList_TableGroup instance={instance} path={'education'} parentField={parentField}
					plain={plain} plainDirtyCounter={plain.state.plainDirtyCounter} ignoreTitle={true}
					readOnly={readOnly} 
					table={{
						columns: [
							{ columnId: 'language', styles: {tdHeader: {width: '10%'}} }, 
							{ columnId: 'name', styles: {tdHeader: {width: '43%'}} },
							{ columnId: 'year', styles: {tdHeader: {width: '12%'}} },
							{ columnId: 'level', styles: {tdHeader: {width: '10%'}} },
							{ columnId: 'qualification', styles: {tdHeader: {width: '17%'}} },
						],
					}}
					styles={{
						table: {width: '100%'},
						trHeader: {height: '43px'}
					}}
				/>
			</div>
		);
	}
}

export default TabAAEducation;
